// @flow
import React from "react";
import styled, { css, keyframes } from "styled-components";
import { fontSize } from "../common/styled-mixins";
import { rgba } from "polished";

const isIronButton =
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ||
  process.env.REACT_APP_DEPLOY_TARGET === "eztrader";

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Loader = styled.div`
  position: relative;
  display: inline-block;

  :before {
    position: absolute;
    display: none;

    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: silver;
    border-radius: 8px;
    content: "";
  }

  :after {
    position: absolute;
    display: none;
    top: 50%;
    left: 50%;
    margin-top: -14px;
    margin-left: -14px;
    box-sizing: border-box;
    width: 28px;
    height: 28px;
    border: 2px solid rgba(255, 255, 255, 0.5);
    border-top: 2px solid #fff;
    border-radius: 50%;
    animation: ${spin} 0.5s linear infinite;
    content: "";
  }

  ${(props) =>
    props.loader &&
    css`
      :before,
      :after {
        display: block;
      }
    `};

  ${(props) =>
    props.isIntlProject &&
    css`
      ::before {
        background-color: #fff;
        border-radius: 32px;
      }

      ::after {
        border-color: ${rgba("#3B9478", 0.5)};
        border-top-color: #3b9478;
      }

      @media (max-width: 374px) {
        display: block;
        margin-bottom: 10px;
        text-align: center;
      }
    `};
`;

const Button = styled.button`
  display: inline-block;
  vertical-align: middle;
  padding: 0 28px;
  margin: 0;
  border: 0;
  border-radius: 8px;
  font-size: ${fontSize(16)};
  font-weight: 700;
  line-height: 39px;
  text-align: center;
  text-decoration: none;
  color: #fff;
  user-select: none;
  cursor: pointer;
  background-color: #60a31c;
  background: linear-gradient(to bottom, #68c703 0%, #60a31c 100%);

  :hover {
    background-color: #68c703;
    background: linear-gradient(to bottom, #60a31c 0%, #68c703 100%);
  }

  :focus {
    outline: none;
  }

  @media (max-width: 480px) {
    padding: 0 10px;
  }

  ${(props) =>
    props.cancelButton &&
    css`
      margin-right: 10px;
      background: linear-gradient(
        to bottom,
        rgb(95, 80, 115),
        rgb(136, 125, 150)
      );

      :hover {
        background: linear-gradient(
          to bottom,
          rgb(136, 125, 150),
          rgb(95, 80, 115)
        );
      }
    `};

  ${({ buttonType }) =>
    isIronButton &&
    css`
      min-width: 150px;
      padding: 14px 20px;
      font-size: 18px;
      line-height: 1;
      font-weight: bold;
      color: #ffffff;
      text-transform: uppercase;
      background: transparent;
      border: 2px solid #ffffff;
      border-radius: 32px;

      &:hover,
      &:focus {
        background-image: none;
        background-color: #ffffff;
        color: ${process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? "#FFD503"
          : "#3b9478"};
      }
      ${buttonType === "register" &&
        css`
          padding: 14px 10px;
        `};
      @media (max-width: 480px) {
        min-width: 100px;
        padding: 10px;
      }
    `};
`;

type Props = {
  id: string,
  loader: boolean,
  className?: string,
};

function BtnFormSubmit({ id, loader, className, ...props }: Props) {
  return (
    <Loader className={className} loader={loader} isIntlProject={isIronButton}>
      <Button type="submit" buttonType={id} id={`s-submit-${id}`} {...props} />
    </Loader>
  );
}

export default BtnFormSubmit;



// WEBPACK FOOTER //
// ./src/components/Auth/BtnFormSubmit.js